/**
 * @file
 * Attaches behaviors for News listing paragraph.
 */

!((document, $) => {

  'use strict';
  Drupal.behaviors.NewsListing = {
    attach: function attach(context) {
      // hack for "Reset button does not use AJAX" issue Views Exposed Form
      let $resetBtn = $(context).find('.form-submit[id^=edit-reset]');
      $resetBtn.on('click keypress', function (e) {
        e.preventDefault();
        location.href = location.origin + location.pathname;
      });
    }
  };
  // eslint-disable-next-line no-undef
})(document, jQuery);
